import { Fragment, useEffect, useState } from "react";
import { Container } from "@/components/container";
import { useParams } from "react-router-dom";
import { useGetRegisteredDMOByIdQuery } from "@/services/DMOManagementService";
import { DMORegisterForm } from "@/types/dmo-management.types";
import DMORegistrationForm from "./components/DMORegistrationForm";

const RegisterDMOUserPage = () => {
  const { id } = useParams<{ id?: string }>();
  const isEditMode = Boolean(id);

  const [initialData, setInitialData] = useState<Partial<DMORegisterForm>>({
    organisation_name: "",
    organisation_type: "",
    contact_email: "",
    linked_regions: "",
    public_homepage: "",
    description: "",
    language: "en",
    email: "",
    name: "",
  });

  const { data: dmoDetails, isLoading: isUserLoading } =
    useGetRegisteredDMOByIdQuery(id as string, {
      skip: !isEditMode,
    });

  useEffect(() => {
    if (!isEditMode || !dmoDetails) return;

    setInitialData({
      organisation_name: dmoDetails.organisation_name || "",
      organisation_type: dmoDetails.organisation_type || "",
      contact_email: dmoDetails.contact_email || dmoDetails.email || "",
      linked_regions: Array.isArray(dmoDetails.linked_regions)
        ? dmoDetails.linked_regions.join("\n")
        : dmoDetails.linked_regions || "",
      public_homepage: dmoDetails.public_homepage || "",
      description: dmoDetails.description || "",
      email: dmoDetails.email || "",
      name: dmoDetails.name || "",
      language: dmoDetails.language || "en",
    });
  }, [isEditMode, dmoDetails]);

  return (
    <Fragment>
      <Container>
        <DMORegistrationForm
          initialData={initialData}
          userId={id}
          isEditMode={isEditMode}
          isUserLoading={isUserLoading}
          showToolbar={true}
        />
      </Container>
    </Fragment>
  );
};

export default RegisterDMOUserPage;
